var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.height && `height: 100%`)},[_c('iframe',{attrs:{"src":_vm.getUrl,"width":"100%","height":"100%","allowfullscreen":"","allow":"cross-origin-isolated","crossorigin":"anonymous","credentialless":"","frameborder":"0"}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }